import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import "../../../../../components/components/css/RoomsCard.css";

const AdmissionRoomsCard = ({ allRooms, initialSelected, onSave, editable }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [selectedRooms, setSelectedRooms] = useState(initialSelected);
  const [tempSelection, setTempSelection] = useState(selectedRooms);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  const toggleRoom = (room) => {
    setTempSelection((prev) => {
      const exists = prev.some((r) => r.id === room.id);
      return exists ? prev.filter((r) => r.id !== room.id) : [...prev, room];
    });
  };

  const getUpdatedRooms = () => tempSelection.map((item) => item.id);

  const handleSave = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const roomIds = getUpdatedRooms();
      
      // Call parent's save handler
      if (onSave) {
        await onSave({ Classes: roomIds });
      }
      
      setSelectedRooms(tempSelection);
      setIsEditing(false);
    } catch (error) {
      console.error("Save error:", error);
      setError("Failed to update. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setTempSelection(selectedRooms);
    setIsEditing(false);
    setError(null);
  };

  return (
    <Box className="rooms-card">
      <Box className="rooms-card-header">
        <Typography variant="header" fontWeight="bold">
          {t(`studentDetails.infoCard.titles.Rooms`)}
        </Typography>
        {editable && (
          <>
            {isEditing ? (
              <Box className="rooms-controls">
                <Button onClick={handleSave} disabled={loading} className="save-btn">
                  {t("actions.save")}
                </Button>
                <Button onClick={handleCancel} disabled={loading} className="cancel-btn">
                  {t("actions.cancel")}
                </Button>
              </Box>
            ) : (
              <Button onClick={() => setIsEditing(true)}>{t("actions.edit")}</Button>
            )}
          </>
        )}
      </Box>

      <Box className="rooms-card-body">
        <Box className="rooms-tags-container">
          {isEditing ? (
            allRooms.map((room) => {
              const isSelected = tempSelection.some((r) => r.id === room.id);
              return (
                <button
                  key={room.id}
                  className={`room-tag-btn ${isSelected ? "selected" : ""}`}
                  onClick={() => toggleRoom(room)}
                >
                  {room.room}
                </button>
              );
            })
          ) : selectedRooms.length > 0 ? (
            selectedRooms.map((room, i) => (
              <Box key={i} className="rooms-tag">
                {room.room}
              </Box>
            ))
          ) : (
            <Typography>{t("studentDetails.infoCard.titles.noRooms")}</Typography>
          )}
        </Box>

        {error && (
          <Typography color="error" sx={{ mt: 1, fontSize: "13px" }}>
            {error}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default AdmissionRoomsCard;